module.exports = __webpack_public_path__ + "img/20190715155240397.9006c5c1.png";